import React, { useContext } from "react";
import clsx from "clsx";
import AuthContext from "../AppAuthContext";
import "../../styling/Styles.css";

/**
 * This component constructs a user's profile icon.
 *
 */
const GithubProfInfo = () => {
  const { state } = useContext(AuthContext);
  

  return (

      <div style={{display: 'flex'}}>
        <div style={{display: 'flex', flexDirection: 'column', alignItems: 'center'}}>
          <img
            src={state.user.git_image_user || '/images/General/User.png'}
            alt="user_logo"
            style={{ width: "5vw", borderRadius: "10%" }}
          />
          <p style = {{marginTop: '0.5rem'}} className={clsx("boldBlue")}> {state.user.login} </p>
        </div>
      </div>
        
  );
};

export default GithubProfInfo;
